var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListhomeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#6c2ad2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2454 4121 c-69 -51 -1623 -1615 -1633 -1644 -47 -125 58 -249 183 -216 36 9 137 106 799 767 l757 757 758 -757 c661 -661 762 -758 798 -767 125 -33 230 91 183 216 -5 15 -113 132 -239 258 l-229 230 -3 392 c-3 379 -4 392 -24 420 -72 97 -205 98 -264 1 -18 -30 -20 -51 -20 -268 l0 -235 -422 421 c-233 232 -434 429 -448 438 -16 11 -46 16 -91 16 -57 0 -71 -4 -105 -29z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 2085 l0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 -155z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 2085 l0 -155 960 0 960 0 0 155 0 155 -960 0 -960 0 0 -155z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1445 l0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 -155z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1445 l0 -155 960 0 960 0 0 155 0 155 -960 0 -960 0 0 -155z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 805 l0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 -155z",
    fill: "#6c2ad2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 805 l0 -155 960 0 960 0 0 155 0 155 -960 0 -960 0 0 -155z",
    fill: "#6c2ad2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListhomeicon);
export default __webpack_public_path__ + "static/media/Listhomeicon.75c5161ba46a73d967614d63da4859ed.svg";
export { ForwardRef as ReactComponent };